import { Hosts, host } from "../host-objects";

export enum MikrotikStaff {
  tihiy_don = "10.127.24.1",
  alexandra = "10.129.40.1",
  general_lavrenenkov = "10.127.60.1",
  anton_chehov = "10.128.0.1",
  igor_stravinskiy = "10.128.68.1",
  volga_star = "10.128.28.1",
  maksim_litvinov = "10.127.224.1",
  sergey_dyagilev = "10.127.244.1",
}

export const getStaffHref = (hostUrl: string = host): string => {
  const name = (Object.keys(Hosts) as Array<keyof typeof Hosts>).find(
    (key) => Hosts[key] === hostUrl
  );
  return name && name in MikrotikStaff
    ? MikrotikStaff[name as keyof typeof MikrotikStaff]
    : MikrotikStaff.sergey_dyagilev;
};
